import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { LocalizedDatePipe } from 'uApp/pipes/localized-date.pipe';
import { SafePipe } from 'uApp/pipes/safe.pipe';


const PIPES = [
    LocalizedDatePipe, SafePipe
];


@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ...PIPES, SafePipe
    ],
    exports: [...PIPES]
})
  export class PipesModule {
  
    static forRoot() {
      return {
        ngModule: PipesModule,
        providers: [],
      };
    }
  }
  